import React from "react";

const Navigation = (props)=>{
    return (
        <div className="map-move-Control">
        <div  onClick={()=>props.pan("up")} className={`map-moveup`}>
            <i class="fas fa-arrow-up"></i>
            <span className="mapup_tooltip">Map - Move up</span>
        </div>
        <div onClick={()=>props.pan("right")}   className="map-moveright">
            <i class="fas fa-arrow-right"></i>
            <span className="mapright_tooltip">Map - Move right</span>
        </div>
        <div onClick={()=>props.pan("down")}  className="map-movedown">
            <i class="fas fa-arrow-down"></i>
            <span className="mapdown_tooltip">Map - Move down</span>
        </div>
        <div onClick={()=>props.pan("left")}  className="map-moveleft">
            <i class="fas fa-arrow-left"></i>
            <span className="mapleft_tooltip">Map - Move left</span>
        </div>
        <div className="map-emptymove"></div>
    </div>
    )
}

export default Navigation